const themeColors = {
    'ftgOrange': '#ee7330',
    'ftgOrangeHover': '#ec613a',
    'ftgBlue': '#004874',
    'ftgGrayBlue': '#7c93aa',
    'ftgGray': '#a4a7aa',
    'ftgGrayHover': '#a0a0a0',
    'ftgGreen': '#8bc467',
    'ftgPastelGreen': '#71a36b',
    'ftgGreenLight': '#b9dca4',
    'secondaryLight': '#f49728',
    'secondaryDark': '#ec613a',
    'secondaryText': '#ffffff',
    'ftgDarkOrange' : '#ab5620',
    'text':'#5e6270',
    'textPrimary': '#004874',
    'textSecondary': '#ee7330',
    'textLight': '#b6bdce',
    'tableBorder': '#dee2e6',
    'inputBorder': '#ced4da',
    'inputBackground': '#f8f9fa',
    'success': '#00D014',
    'green': '#4da415',
    'danger': '#eb6460',
    'dangerHover': '#ee3530',
    'warning': '#FFB70F',
    'info': '#00D0BD',
    'dark': '#464D69',
    'default': '#b6babd',
    'greyLighten': '#A5A7B2',
    'grey': '#677080',
    'white': '#FFFFFF',
    'purple': '#896BD6',
    'yellow': '#D46B08'
}

export default themeColors;